function css(property, value) {
  return ('CSS' in window && 'supports' in window.CSS) && window.CSS.supports(property, value);
}

export const hasObjectFitCover = css('object-fit', 'cover'); // eslint-disable-line



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/compability.js